require('./globalPositionExpensesEmptyState.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');

// @components
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const { FormattedText, formatText } = require('core/i18n').i18n;

class GlobalPositionExpensesEmptyState extends Component {
    render() {
        const { message } = this.props;
        const url = `/myprofile/global/expenses-by-category/all-categories/${formatText('urlGobalPosition-bothAccount')}/${formatText('urlGobalPosition-allAccounts')}`;
        return (
            <div className="global-position-expenses-empty-state text-center">
                <EmptyState primaryText={message} textRegular iconType="noitems-banking"/>
                <OKLink inverse to={url} >
                    <FormattedText value="myGlobalPositionExpenses-showBreakdown" />
                </OKLink>
            </div>
        );
    }
}

GlobalPositionExpensesEmptyState.propTypes = {
    message: PropTypes.string,
    dark: PropTypes.bool
}

module.exports = GlobalPositionExpensesEmptyState;
